import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Icon from '@mdi/react';
import { mdiBankCircle, mdiInvoiceList, mdiInvoiceTextRemove, mdiMessageBadge } from '@mdi/js';

const pageSize = 20;

export const InvoicesPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Facturación', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        ariaLabels={{
                            itemSelectionLabel: (e, i) => `select ${i.name}`,
                            selectionGroupLabel: "Item selection"
                        }}
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#invoices/issued",
                                name: (<span>
                                    <Icon path={mdiInvoiceList} size={1.5} /> Emitidas</span>),
                                description: "Listado de facturas emitidas a la propiedad. Permite descarga de tanto DTE como XML",
                            },
                            {
                                id: "#invoices/notify",
                                name: (<span>
                                    <Icon path={mdiMessageBadge} size={1.5} /> Notificar</span>),
                                description: "Permite ingresar manualmente el comprobante de una transferencia electrónica",
                            },
                            {
                                id: "#invoices/pendings",
                                name: (<span>
                                    <Icon path={mdiInvoiceTextRemove} size={1.5} /> Vencidas</span>),
                                description: "Listado de facturas que no han sido canceladas y podrían generar un corte de servicio",
                            },
                        ]}
                        header={<Header><Icon path={mdiBankCircle} size={2} /> Facturación</Header>}
                    />
                </>
            }
        />
    );
};
